import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import ReactTelephoneInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import { isNotNillNorEmpty } from '../../../../utils/helpers';
import messages from '../messages';
import flagsImagePath from './flags.png';
import useStyles from './styles';

const CountrySelector = ({ onChange, value, preferredCountries }) => {
  const intl = useIntl();
  const classes = useStyles({
    preferred: intl.formatMessage(messages.preferred),
    all: intl.formatMessage(messages.all),
    hasPreferredCountries: isNotNillNorEmpty(preferredCountries),
  });
  return (
    <ReactTelephoneInput
      className={`${classes.root} country-selector`}
      autoFormat={false}
      defaultCountry={value}
      value={value}
      flagsImagePath={flagsImagePath}
      onChange={(dial, { iso2 }) => onChange(iso2)}
      preferredCountries={preferredCountries}
    />
  );
};

CountrySelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  preferredCountries: PropTypes.array,
};

export default CountrySelector;
